module.exports = __webpack_public_path__ + "img/bishop-henry-mcneal-turner.1cf62c38.png";